/// <reference path="../../../../core/web/site/embedded/script/core.js" />
if (!rtAPI) var rtAPI = {};

//#region Init

rtAPI.loadingPanel = {
    'active': true,
    'text': 'Loading. Please wait......'
};

//#endregion

//#region Visibility

rtAPI.loadingPanel.show = function () {
    if (!this.active) return;
    this.getDiv().style.display = "flex";
    document.body.classList.add("postback-lock");
}

rtAPI.loadingPanel.hide = function () {
    if (!this.active) return;
    this.getDiv().style.display = "none";
    document.body.classList.remove("postback-lock");
}

//#endregion

//#region Render

rtAPI.loadingPanel.getDiv = function () {
    var loadingPanelDiv = document.getElementById('postback-content-overlay');
    if (!loadingPanelDiv) {
        loadingPanelDiv = document.createElement("div");
        loadingPanelDiv.id = 'postback-content-overlay';
        loadingPanelDiv.className = 'rt-postback-content-overlay';
        loadingPanelDiv.style.display = 'none';
        document.body.insertBefore(loadingPanelDiv, document.body.firstChild);

        loadingPanelDivContent = document.createElement("div");
        loadingPanelDivContent.className = 'rt-postback-content-overlay-message';
        loadingPanelDivContent.innerHTML = this.text;
        loadingPanelDiv.appendChild(loadingPanelDivContent);
    }
    return loadingPanelDiv
}

//#endregion

